import {
  responsiveAspectVariants,
  responsiveDisplayVariants,
  responsiveHeightVariants,
  responsiveMaxHeightVariants,
  responsiveMaxWidthVariants,
  responsiveMbVariants,
  responsiveMinHeightVariants,
  responsiveMinWidthVariants,
  responsiveMlVariants,
  responsiveMrVariants,
  responsiveMtVariants,
  responsivePbVariants,
  responsivePlVariants,
  responsivePositionVariants,
  responsivePrVariants,
  responsivePtVariants,
  responsiveTextAlignmentVariants,
  responsiveTextColorVariants,
  responsiveTextSizeVariants,
  responsiveWidthVariants,
} from "@/constants/tailwindClasses"
import { storyblokEditable } from "@storyblok/react/rsc"

import { cn } from "@/lib/utils"
import { getRenderedRichText } from "@/components/ui/helpers/richtextRenderer"
import { ResponsiverichtextStoryblok } from "@/components/storyblok/component-types"

export default function ResponsiveRichText({
  blok,
  sbLocale,
}: {
  blok: ResponsiverichtextStoryblok
  sbLocale?: string
}) {
  const renderedRichText = getRenderedRichText(blok.richtext, sbLocale)
  return (
    <div
      className={cn(
        { "drop-shadow-3xl": blok.dropShadow },
        responsiveDisplayVariants(blok.display),
        responsivePositionVariants(blok.position),
        responsiveWidthVariants(blok.width),
        responsiveHeightVariants(blok.height),
        responsiveMinWidthVariants(blok.minWidth),
        responsiveMaxWidthVariants(blok.maxWidth),
        responsiveMinHeightVariants(blok.minHeight),
        responsiveMaxHeightVariants(blok.maxHeight),
        responsiveAspectVariants(blok.aspect),
        responsiveMlVariants(blok.ml),
        responsiveMrVariants(blok.mr),
        responsiveMtVariants(blok.mt),
        responsiveMbVariants(blok.mb),
        responsivePlVariants(blok.pl),
        responsivePrVariants(blok.pr),
        responsivePtVariants(blok.pt),
        responsivePbVariants(blok.pb),
        responsiveTextSizeVariants(blok.textSize),
        responsiveTextAlignmentVariants(blok.textAlignment),
        responsiveTextColorVariants(blok.textColor)
      )}
      {...storyblokEditable(blok)}
    >
      {blok.useDropShadow}
      {renderedRichText}
    </div>
  )
}
